import { useState } from "react";
export default function ResourceList({children}) {
  const [listExpanded, setListExpanded] = useState(false);
  const threshold = 4  
  return (
    <>
      <ul className="lexcms-product-resource-list" >
        {children.slice(0, threshold)}
        {listExpanded &&
          children.slice(threshold, children.length ) 
        }
      </ul>
      {children.length > threshold && 
      <a
        className={`lexcms-filter-see-more ${
          listExpanded ? "lexcms-active" : ""
        }`}
        onClick={() => setListExpanded(!listExpanded)}
      >
        
        {listExpanded ? "See Less" : "See More"}{" "}
      </a>
      }
    </>
  );
}
